import ErrorBoundary from "../components/ErrorBoundary.jsx"
import HeaderGlobal from "../components/global/HeaderGlobal.jsx"
import Search from "../components/global/Search.jsx"
const MainLayout = ({ children, search }) => {
	return (
		<div className="fancy-bg">
			<HeaderGlobal />
			<main>
				{
					search && <Search />
				}
				<ErrorBoundary fallback="Your App ran into a problem and needs to restart">
					{children}
				</ErrorBoundary>
			</main>
		</div>
	)
}

export default MainLayout
